module.exports = () => {
  return {
    brand_image_file: {
      label: '品牌形象',
      type: 'form-upload',
      props: {
        tip: '尺寸要求为512px*512px，格式为jpg/jpeg/png，文件大小小于50k',
        restriction: {
          width: 512,
          height: 512,
          max_size: 50 * 1024,
        },
        isFile: true,
      },
      value: {
        url: '',
        file: null,
      },
      rules: { required: true, trigger: ['change'], message: '请上传品牌形象' },
    },
    name: {
      label: '品牌名称',
      type: 'input',
      value: '',
      rules: { required: true, trigger: ['change'], message: '请输入品牌名称' },
    },
  };
};
